import { createContext } from "react";
import type { useAuth } from "react-oidc-context";

export type AzureEntraAuthState = Pick<
  ReturnType<typeof useAuth>,
  | "isAuthenticated"
  | "user"
  | "signinRedirect"
  | "removeUser"
  | "isLoading"
  | "error"
>;

export const AzureEntraContext = createContext<AzureEntraAuthState | undefined>(
  undefined,
);
